<mat-card class="schedule-settings-container">
    <mat-card-title *ngIf="!hideHeader">Scheduler Settings</mat-card-title>

    <form class="schedule-settings-form" [formGroup]="formGroup" ngNativeValidate>
        <mat-grid-list cols="2" rowHeight="95px">
            <mat-grid-tile>
                <div class="container">
                    <mat-slide-toggle class="turn-on-slider" [formControl]="turnOnScheduler"
                        (change)="handleTurnOnSliderChange()">
                        Turn On</mat-slide-toggle>
                </div>
            </mat-grid-tile>
            <mat-grid-tile></mat-grid-tile>
            <mat-grid-tile>
                <mat-form-field appearance="fill">
                    <mat-label>Auto-Check interval</mat-label>
                    <input matInput type="number" placeholder="e.g. 30" [formControl]="checkIntervalSecondsControl"
                        min="{{minCheckIntervalSeconds}}">
                    <span matSuffix class="value-suffix">
                        <mat-icon class="help-icon"
                            [matTooltip]="'Time between the auto-schedule will check for new jobs that need to be auto-started.'">
                            info
                        </mat-icon>Seconds
                    </span>
                    <mat-error *ngIf="checkIntervalSecondsControl.invalid && checkIntervalSecondsControl.errors.min">Min
                        interval: {{minCheckIntervalSeconds}} seconds
                    </mat-error>
                    <mat-error *ngIf="checkIntervalSecondsControl.invalid && checkIntervalSecondsControl.errors.max">Max
                        interval: {{maxCheckIntervalSeconds}} seconds
                    </mat-error>
                    <mat-error
                        *ngIf="checkIntervalSecondsControl.invalid && checkIntervalSecondsControl.errors.pattern">Only
                        integer numbers allowed
                    </mat-error>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
                <mat-form-field appearance="fill">
                    <mat-label>Total Concurrent Jobs Allowed</mat-label>
                    <input matInput type="number" placeholder="e.g. 5" [formControl]="maxConcurrentProcessesControl"
                        min="{{minConcurrentProcesses}}">
                    <span matSuffix class="value-suffix">
                        <mat-icon class="help-icon"
                            [matTooltip]="'Maximum number of jobs the scheduler is allowed to run at any one given time. This may be limited/overriden by compute processing power.'">
                            info
                        </mat-icon>Jobs
                    </span>
                    <mat-error
                        *ngIf="maxConcurrentProcessesControl.invalid && maxConcurrentProcessesControl.errors.min">
                        Min Jobs count: {{minConcurrentProcesses}}
                    </mat-error>
                    <mat-error
                        *ngIf="maxConcurrentProcessesControl.invalid && maxConcurrentProcessesControl.errors.max">
                        Max Jobs count: {{maxConcurrentProcesses}}
                    </mat-error>
                    <mat-error
                        *ngIf="maxConcurrentProcessesControl.invalid && maxConcurrentProcessesControl.errors.pattern">
                        Only integer numbers allowed
                    </mat-error>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
                <mat-form-field appearance="fill">
                    <mat-label>Maximum running threads count</mat-label>
                    <input matInput type="number" placeholder="{{threadsCountPlaceholder}}"
                        [formControl]="maxThreadsCountControl" min="{{minThreadsCount}}" max="{{maxThreadsCount}}">
                    <span matSuffix class="value-suffix">
                        <mat-icon class="help-icon"
                            [matTooltip]="'Maximum number of threads should be set according to preliminary calculation capacity of ZAPI infrastructure.'">
                            info
                        </mat-icon>Threads
                    </span>
                    <mat-error *ngIf="maxThreadsCountControl.invalid && maxThreadsCountControl.errors.min">
                        Min threads count: {{validatedMinThreadsCount}}
                    </mat-error>
                    <mat-error *ngIf="maxThreadsCountControl.invalid && maxThreadsCountControl.errors.max">
                        Max threads count: {{maxThreadsCount}}
                    </mat-error>
                    <mat-error *ngIf="maxThreadsCountControl.invalid && maxThreadsCountControl.errors.pattern">
                        Only integer numbers allowed
                    </mat-error>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
                <mat-form-field appearance="fill">
                    <mat-label>Pause Duration</mat-label>
                    <input matInput type="number" placeholder="1 - 96 hours" [formControl]="pauseDurationControl"
                        min="{{minPauseDuration}}" max="{{maxPauseDuration}}">
                    <span matSuffix class="value-suffix">
                        <mat-icon class="help-icon"
                            [matTooltip]="'The auto-scheduler can be paused for a maximum of 96 hours. The expiration timestamp is displayed in UTC time. While the scheduler is paused, any job can be manually started. '">
                            info
                        </mat-icon>Hours
                    </span>
                    <mat-error *ngIf="pauseDurationControl.invalid && pauseDurationControl.errors.min">
                        Min duration (hours): {{minPauseDuration}}
                    </mat-error>
                    <mat-error *ngIf="pauseDurationControl.invalid && pauseDurationControl.errors.max">
                        Max duration (hours): {{maxPauseDuration}}
                    </mat-error>
                    <mat-error *ngIf="pauseDurationControl.invalid && pauseDurationControl.errors.pattern">
                        Only integer numbers allowed
                    </mat-error>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
                <mat-form-field appearance="fill">
                    <mat-label>Maximum PRs bunch Size</mat-label>
                    <input matInput type="number" placeholder="{{maxBunchSizePlaceholder}}"
                        [formControl]="maxPRsBunchSizeAllowedControl" min="{{minPRsBunchSizeAllowed}}"
                        max="{{maxPRsBunchSizeAllowed}}">
                    <span matSuffix class="value-suffix">
                        <mat-icon class="help-icon"
                            [matTooltip]="'Maximum number of Property Records in a bunch should be set according to preliminary calculation capacity of ZAPI infrastructure.'">
                            info
                        </mat-icon>PRs
                    </span>
                    <mat-error
                        *ngIf="maxPRsBunchSizeAllowedControl.invalid && maxPRsBunchSizeAllowedControl.errors.min">
                        Min bunch size: {{minPRsBunchSizeAllowed}}
                    </mat-error>
                    <mat-error
                        *ngIf="maxPRsBunchSizeAllowedControl.invalid && maxPRsBunchSizeAllowedControl.errors.max">
                        Max bunch size: {{maxPRsBunchSizeAllowed}}
                    </mat-error>
                    <mat-error
                        *ngIf="maxPRsBunchSizeAllowedControl.invalid && maxPRsBunchSizeAllowedControl.errors.pattern">
                        Only integer numbers allowed
                    </mat-error>
                </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile>
                <mat-form-field appearance="fill">
                    <mat-label>Default PRs bunch Size</mat-label>
                    <input matInput type="number" placeholder="{{defaultBunchSizePlaceholder}}"
                        [formControl]="defaultPRsBunchSizeControl" min="{{minPRsBunchSizeAllowed}}"
                        max="{{maxPRsBunchSizeAllowed}}">
                    <span matSuffix class="value-suffix">
                        <mat-icon class="help-icon"
                            [matTooltip]="'Default number of Property Records in a bunch should be set according to preliminary calculation capacity of ZAPI infrastructure.'">
                            info
                        </mat-icon>PRs
                    </span>
                    <mat-error *ngIf="defaultPRsBunchSizeControl.invalid && defaultPRsBunchSizeControl.errors.min">
                        Min bunch size: {{minPRsBunchSizeAllowed}}
                    </mat-error>
                    <mat-error *ngIf="(defaultPRsBunchSizeControl.invalid && defaultPRsBunchSizeControl.errors.max)">
                        Max bunch size: {{maxDefaultBunchSize}}
                    </mat-error>
                    <mat-error *ngIf="defaultPRsBunchSizeControl.invalid && defaultPRsBunchSizeControl.errors.pattern">
                        Only integer numbers allowed
                    </mat-error>
                </mat-form-field>
            </mat-grid-tile>
        </mat-grid-list>
        <div class="dialog-footer">
            <mat-dialog-actions style="flex-direction: column;">
                <div *ngIf="schedulerSettings?.isPaused">
                    <span title="{{schedulerSettings.pauseInfo}}">Paused
                        until: {{schedulerSettings.pauseEndStr}}</span>
                    <br>
                </div>
                <div style="display: flex;">
                    <button *ngIf="schedulerSettings?.isPaused" mat-flat-button color="accent"
                        class="clear-pause-button" (click)="clearPause()">Clear
                        pause</button>
                    <app-process-small-spinner class="save-button-spinner"
                        [isVisible]="saveActionState.isWaitingActionFinish">
                    </app-process-small-spinner>
                    <button mat-flat-button color="primary" (click)="save()" [disabled]="formGroup.invalid">Save
                        Settings</button>
                </div>
            </mat-dialog-actions>
        </div>
    </form>
    <app-spinner *ngIf="showSpinner" [isInternal]="true"></app-spinner>
</mat-card>